const DEFAULT_VALUES = {
  fineAmount: 0,
  licencePoints: 0,
  drivingBanPeriod: 0,
};

const calculate = (data) => {
  if (data.SPEED === "LESS_THAN_80") {
    return {
      fineAmount: 25,
    };
  } else if (data.SPEED === "81_TO_100") {
    switch (data.DISTANCE_METRES) {
      case "5_OUT_OF_10":
        return {
          fineAmount: 75,
          licencePoints: 1,
        };
      case "4_OUT_OF_10":
        return {
          fineAmount: 100,
          licencePoints: 1,
        };
      case "3_OUT_OF_10":
        return {
          fineAmount: 160,
          licencePoints: 1,
        };
      case "2_OUT_OF_10":
        return {
          fineAmount: 240,
          licencePoints: 1,
        };
      case "1_OUT_OF_10":
        return {
          fineAmount: 320,
          licencePoints: 1,
        };
      default:
        return DEFAULT_VALUES;
    }
  } else if (data.SPEED === "101_TO_130") {
    switch (data.DISTANCE_METRES) {
      case "5_OUT_OF_10":
        return {
          fineAmount: 75,
          licencePoints: 1,
        };
      case "4_OUT_OF_10":
        return {
          fineAmount: 100,
          licencePoints: 1,
        };
      case "3_OUT_OF_10":
        return {
          fineAmount: 160,
          licencePoints: 2,
          drivingBanPeriod: 1,
        };
      case "2_OUT_OF_10":
        return {
          fineAmount: 240,
          licencePoints: 2,
          drivingBanPeriod: 2,
        };
      case "1_OUT_OF_10":
        return {
          fineAmount: 320,
          licencePoints: 2,
          drivingBanPeriod: 3,
        };
      default:
        return DEFAULT_VALUES;
    }
  } else if (data.SPEED === "MORE_THAN_130") {
    switch (data.DISTANCE_METRES) {
      case "5_OUT_OF_10":
        return {
          fineAmount: 100,
          licencePoints: 1,
        };
      case "4_OUT_OF_10":
        return {
          fineAmount: 180,
          licencePoints: 1,
        };
      case "3_OUT_OF_10":
        return {
          fineAmount: 240,
          licencePoints: 2,
          drivingBanPeriod: 1,
        };
      case "2_OUT_OF_10":
        return {
          fineAmount: 320,
          licencePoints: 2,
          drivingBanPeriod: 2,
        };
      case "1_OUT_OF_10":
        return {
          fineAmount: 400,
          licencePoints: 2,
          drivingBanPeriod: 3,
        };
      default:
        return DEFAULT_VALUES;
    }
  }

  return DEFAULT_VALUES;
};

export default calculate;
